import React, { Component } from 'react';
import { currencyFormat, numberFormat } from '../helpers/index';

class FactsComponent extends Component {
    render () {

        const {
            listingType,
            listingPricePeriod
        } = this.props.propertyInfo;

        const {
            yearBuilt,
            sqft,
            price,
            bedrooms,
            baths,
            halfBath,
            garageBays,
            lotSize,
            bathsAll
        } = this.props.heroInfo;

        let priceBlock = null;
        let sqftBlock = null;
        let yearBlock = null;
        let bathsAllBlock = null;

        const isRent = listingType.toLowerCase() === 'for rent' || listingType.toLowerCase() === 'for lease';

        const rent = isRent
            ? 'rental: '
            : null;

        const period = isRent && listingPricePeriod && listingPricePeriod.toLowerCase() !== 'custom'
            ? `/${listingPricePeriod}`
            : null;

        if (price.type === 'value' && price.value) {
            priceBlock = (
                <li>
                    <h3>{rent}{currencyFormat.format(price.value)}{period}</h3>
                    <span>price</span>
                </li>
            )
        } else if (price.type === 'range' && price.from && price.to) {
            priceBlock = (
                <li>
                    <h3>{rent}{currencyFormat.format(price.from)} - {currencyFormat.format(price.to)}{period}</h3>
                    <span>price</span>
                </li>
            )
        }

        if (sqft.type === 'value' && sqft.value) {
            sqftBlock = (
                <li>
                    <h3>{numberFormat.format(sqft.value)}</h3>
                    <span>square feet</span>
                </li>
            )
        } else if (sqft.type === 'range' && sqft.from && sqft.to) {
            sqftBlock = (
                <li>
                    <h3>{numberFormat.format(sqft.from)} - {numberFormat.format(sqft.to)}</h3>
                    <span>square feet</span>
                </li>
            )
        }

        if (!!yearBuilt && yearBuilt !== '0') {
            yearBlock = (
                <li>
                    <h3>{yearBuilt}</h3>
                    <span>year built</span>
                </li>
            )
        }

        const bedroomsBlock = bedrooms && bedrooms != '0'
            ? (
                <li>
                    <h3>{bedrooms}</h3>
                    <span>bed</span>
                </li>
            )
            : null;

            bathsAllBlock = bathsAll ? (
                <li>
                    <h3>{bathsAll}</h3>
                    <span>bath</span>
                </li>
            ) : null;

        // if (baths && halfBath) {
        //     bathsAllBlock = (
        //         <li>
        //             <h3>{baths} full</h3>
        //             <span>{halfBath} half bath</span>
        //         </li>
        //     );
        // } else if (baths && !halfBath) {
        //     bathsAllBlock = (
        //         <li>
        //             <h3>{baths} full</h3>
        //             <span>bath</span>
        //         </li>
        //     );
        // } else if (!baths && halfBath) {
        //     bathsAllBlock = (
        //         <li>
        //             <h3>{halfBath}</h3>
        //             <span>half bath</span>
        //         </li>
        //     );
        // }

      const garageBlock = !!garageBays && garageBays != '0'
        ? (
          <li>
            <h3>{garageBays}</h3>
            <span>garage bays</span>
          </li>
        )
        : null;

        const lotSizeBlock = lotSize && lotSize != '0'
            ? (
                <li>
                    <h3>{lotSize}</h3>
                    <span>lot size</span>
                </li>
            )
            : null;

        if (!(priceBlock || sqftBlock || bedroomsBlock || bathsAllBlock || lotSizeBlock || yearBlock)) {
            return null;
        }

        return (
            <div className="facts-component">
                <ul>
                    {priceBlock}
                    {sqftBlock}
                    {bedroomsBlock}
                    {bathsAllBlock}
                    {garageBlock}
                    {lotSizeBlock}
                    {yearBlock}
                </ul>
            </div>
        )
    }
}

export default FactsComponent;
